module.exports = __webpack_public_path__ + "img/volume-xmark.b30ba405.svg";